import React from "react";
import pizzalabel from "assets/img/pizzalabel.svg";

const OfferItemsList = ({ offer }) => {

  const containerStyle = {
    borderRadius: "12px",
    padding: "16px",
    width: "100%",
    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    overflowX: "hidden",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
  };

  const scrollContainerStyle = {
    maxHeight: offer?.items?.length > 2 ? "200px" : "unset",
    overflowY: offer?.items?.length > 2 ? "auto" : "unset",
    width: "100%",
    paddingRight: "6px",
    boxSizing: "border-box",
  };

  const itemRowStyle = {
    backgroundColor: "#f9f9f9",
    border: '1.5px solid rgb(215, 24, 40)',
    borderRadius: "10px",
    marginBottom: "12px",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    transition: "transform 0.2s, box-shadow 0.2s",
    width: "100%",
    boxSizing: "border-box",
  };

  const itemRowHoverStyle = {
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
  };

  return (
    <div
      className="w-100 d-flex flex-column align-items-start"
      style={containerStyle}
    >
      <div style={scrollContainerStyle}>
        {offer?.items?.length > 0 && offer?.items.map((item, index) => (
          <div
            key={index}
            className="offer-item-row"
            style={itemRowStyle}
            onMouseEnter={(e) =>
              Object.assign(e.currentTarget.style, itemRowHoverStyle)
            }
            onMouseLeave={(e) =>
              Object.assign(e.currentTarget.style, itemRowStyle)
            }
          >
            <div className="d-flex align-items-center">
              <img
                src={item.image || pizzalabel}
                alt={item.itemName}
                style={{
                  width: "44px",
                  height: "44px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginRight: "16px",
                  border: '1px solid rgb(215, 24, 40)',
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                }}
              />
              <div>
                <div
                  className="fw-semibold text-dark"
                  style={{ fontSize: "15.5px" }}
                >
                  {item.itemName}
                </div>
                <div className="text-muted" style={{ fontSize: "13px" }}>
                  Variant: {item.variant}
                </div>
              </div>
            </div>
            <div
              className="fw-bold text-dark"
              style={{ fontSize: "15px" }}
            >
              ×{item.quantity}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OfferItemsList;
